import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={slide.image}
        alt="片多多影视"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-accent-300 text-sm md:text-base font-medium mb-3 tracking-wider animate-fadeIn">
              PIANDUODUO MOVIE
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
              {slide.title}
            </h1>
            <p className="text-lg md:text-2xl text-white/90 mb-3 font-medium">
              {slide.subtitle}
            </p>
            <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
              {slide.description}
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line text-lg"></i>
                </span>
                {slide.cta}
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all duration-300 backdrop-blur-sm whitespace-nowrap text-sm cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-information-line text-lg"></i>
                </span>
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all duration-300 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all duration-300 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}